export default "__VITE_ASSET__BmyfGrki__"